<template>
    <v-app>
        <Navbar v-if="$route.meta.showNav" :key="$route.path"/>
        <WithdrawalDialog/>
        <NomineeDialog/>
        <v-main>
            <Loader/>
            <SessionOver/>
            <router-view/>
        </v-main>
  </v-app>
</template>

<script>
import Navbar from '@/components/navbar/navbar.vue'
import Loader from '@/components/loader.vue'
import SessionOver from '@/components/sessionOverDialog.vue'
import WithdrawalDialog from '@/components/withdrawal/withdrawalDialog'
import NomineeDialog from '@/components/addNominee/addNomineeDialog'

export default {
    name: 'App',
    created () {
        this.$store.commit('isNotLoading')
    },
    components: {
        Navbar,
        Loader,
        SessionOver,
        WithdrawalDialog,
        NomineeDialog
    }
}
</script>
<style lang="scss" scoped>
@import url('https://rsms.me/inter/inter.css');
    ::v-deep .v-application--wrap {
        overflow: hidden !important;
    }

    ::v-deep .sprite {
        background-image: url(#{$sprite-path});
        background-repeat: no-repeat
    }

    html { font-family: 'Inter', sans-serif; }
</style>
